import React, { useEffect, useState } from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import TransactionFlowDefaultTemplate from "../../others/transactionFlowDefaultTemplate";
import { useDispatch, useSelector } from "react-redux";
import { setUploadHighlight } from "../../../store/slices/misc/highlightSlice";
import { ReactTyped } from "react-typed";
import { Drawer, Flex, Popover, Spin, Table, Tooltip } from "antd";
import { Badge, Button, Spinner } from "reactstrap";
import {
  Icon,
  TooltipComponent,
  Button as PlainButton,
} from "../../../components/Component";
import miscService from "../../../api/misc/misc";
import Swal from "sweetalert2";
import { uploadApis } from "../../../api/Uploads";
import { useNavigate } from "react-router-dom";

dayjs.extend(customParseFormat);

const drawerColConfig: any = {
  supplierCreate: {
    title: "Supplier Creation",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "excelValidations",
        key: "validationStatus",
        width: 120,
        fixed: "left",
        render: (validations: string[], record: any) =>
          validations?.length > 0 ? (
            <Popover
              placement="right"
              content={
                <div>
                  <p>{validations?.join(", ")}</p>
                </div>
              }
              title={<span style={{ color: "red" }}>Failed</span>}
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                placement="right"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              content={
                <div>
                  <p>
                    {record?.supplierID} ({record?.supplierName}) Is Valid
                    Record
                  </p>
                </div>
              }
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          ),
      },
      {
        title: "Supplier ID",
        dataIndex: "supplierID",
        key: "supplierID",
        width: 150,
      },
      {
        title: "Phone Number",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        width: 150,
      },
      {
        title: "Supplier Name",
        dataIndex: "supplierName",
        key: "supplierName",
        width: 200,
      },
      {
        title: "Account Number",
        dataIndex: "accountNumber",
        key: "accountNumber",
        width: 200,
      },
      {
        title: "CIN",
        dataIndex: "cin",
        key: "cin",
        width: 200,
      },
      {
        title: "PAN",
        dataIndex: "pan",
        key: "pan",
        width: 150,
      },
      {
        title: "Area",
        dataIndex: "area",
        key: "area",
        width: 150,
      },
      {
        title: "City",
        dataIndex: "city",
        key: "city",
        width: 150,
      },
      {
        title: "District",
        dataIndex: "district",
        key: "district",
        width: 150,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 200,
      },
      {
        title: "GSTIN",
        dataIndex: "gstin",
        key: "gstin",
        width: 200,
      },
      {
        title: "Branch",
        dataIndex: "branch",
        key: "branch",
        width: 150,
      },
      {
        title: "Pincode",
        dataIndex: "pincode",
        key: "pincode",
        width: 100,
      },
      {
        title: "Bank Name",
        dataIndex: "bankName",
        key: "bankName",
        width: 150,
      },
      {
        title: "IFSC Code",
        dataIndex: "ifscCode",
        key: "ifscCode",
        width: 150,
      },
      {
        title: "Brand Name",
        dataIndex: "brandName",
        key: "brandName",
        width: 150,
      },
      {
        title: "Trade Name",
        dataIndex: "tradeName",
        key: "tradeName",
        width: 150,
      },
      {
        title: "Categories",
        dataIndex: "categories",
        key: "categories",
        width: 150,
      },
      {
        title: "Credit Days",
        dataIndex: "creditDays",
        key: "creditDays",
        width: 120,
      },

      {
        title: "Address Line 1",
        dataIndex: "addressLine1",
        key: "addressLine1",
        width: 200,
      },
      {
        title: "Address Line 2",
        dataIndex: "addressLine2",
        key: "addressLine2",
        width: 200,
      },
      {
        title: "Payment Terms",
        dataIndex: "paymentTerms",
        key: "paymentTerms",
        width: 150,
      },

      {
        title: "Business Type",
        dataIndex: "bussinessType",
        key: "bussinessType",
        width: 150,
      },
      {
        title: "Contact Person",
        dataIndex: "contactPerson",
        key: "contactPerson",
        width: 200,
      },
      {
        title: "Delivery Lead Days",
        dataIndex: "deliveryLeadDays",
        key: "deliveryLeadDays",
        width: 150,
      },
      {
        title: "Account Holder Name",
        dataIndex: "accountHolderName",
        key: "accountHolderName",
        width: 200,
      },
      {
        title: "Application Access",
        dataIndex: "applicationAccess",
        key: "applicationAccess",
        width: 150,
      },
      {
        title: "Incorporation Date",
        dataIndex: "incorporationDate",
        key: "incorporationDate",
        width: 180,
        render: (text: any) => {
          if (!text) return <span>--</span>;
          const parsed = dayjs(
            text,
            ["DD-MM-YYYY", "D-M-YYYY", "DD/MM/YYYY", "YYYY-MM-DD"],
            true
          );
          return (
            <span>{parsed.isValid() ? parsed.format("DD-MM-YYYY") : text}</span>
          );
        },
      },
    ],
    tableWidth: 5000,
  },
  materialCreate: {
    title: "Material Creation",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "excelValidations",
        key: "validationStatus",
        width: 120,
        fixed: "left",
        render: (validations: string[], record: any) =>
          validations?.length > 0 ? (
            <Popover
              placement="right"
              content={
                <div>
                  <p>{validations?.join(", ")}</p>
                </div>
              }
              title={<span style={{ color: "red" }}>Failed</span>}
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                placement="right"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              content={
                <div>
                  <p>
                    {record?.materialCode} ({record?.materialName}) Is Valid
                    Record
                  </p>
                </div>
              }
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          ),
      },
      // {
      //   title: "Material Code",
      //   dataIndex: "materialCode",
      //   key: "materialCode",
      //   width: 150,
      // },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        width: 200,
      },
      {
        title: "Product Life",
        dataIndex: "productLife",
        key: "productLife",
        width: 150,
      },
      {
        title: "Specification",
        dataIndex: "specification",
        key: "specification",
        width: 150,
      },
      {
        title: "UOM Conversion Ratio",
        dataIndex: "uomConversionRatio",
        key: "uomConversionRatio",
        width: 200,
      },
      {
        title: "Primary Unit of Measure",
        dataIndex: "primaryUnitOfMeasure",
        key: "primaryUnitOfMeasure",
        width: 200,
      },
      {
        title: "Secondary Unit of Measure",
        dataIndex: "secondaryUnitOfMeasure",
        key: "secondaryUnitOfMeasure",
        width: 200,
      },
    ],
    tableWidth: 1000,
  },
  stockCreate: {
    title: "Stock Creation",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "excelValidations",
        key: "validationStatus",
        width: 120,
        fixed: "left",
        render: (validations: string[], record: any) =>
          validations?.length > 0 ? (
            <Popover
              placement="right"
              content={
                <div>
                  <p>{validations?.join(", ")}</p>
                </div>
              }
              title={<span style={{ color: "red" }}>Failed</span>}
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                placement="right"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              content={
                <div>
                  <p>This Is Valid Record</p>
                </div>
              }
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          ),
      },
      {
        title: "Site ID",
        dataIndex: "siteID",
        key: "siteID",
        width: 100,
      },
      {
        title: "Material ID",
        dataIndex: "materialID",
        key: "materialID",
        width: 100,
      },
      {
        title: "Reorder Point",
        dataIndex: "reorderPoint",
        key: "reorderPoint",
        width: 100,
      },
      {
        title: "Stock Quantity",
        dataIndex: "stockQuantity",
        key: "stockQuantity",
        width: 100,
      },
      {
        title: "Maximum Stock Level",
        dataIndex: "maximumStockLevel",
        key: "maximumStockLevel",
        width: 100,
      },
      {
        title: "Minimum Stock Level",
        dataIndex: "minimumStockLevel",
        key: "minimumStockLevel",
        width: 100,
      },
    ],
    tableWidth: 500,
  },
  "purchase-request-upload": {
    title: "Purchase Request Upload",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        fixed: "left",
        render: (status: any, record: any) => {
          const errorData = record?.Error;
          const errorsList = Array.isArray(errorData)
            ? errorData
            : errorData
              ? [errorData]
              : [];

          const isFailed = errorsList.length > 0 || status === "Failed";

          return isFailed ? (
            <Popover
              placement="right"
              title={<span style={{ color: "red" }}>Failed</span>}
              content={
                <div>
                  {errorsList.map((err: string, i: number) => (
                    <p key={i}>{err}</p>
                  ))}
                </div>
              }
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
              content={<p>{record?.prNumber} is a valid record</p>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          );
        },
      },
      {
        title: "Site Name",
        dataIndex: "siteName",
        key: "siteName",
        width: 200,
      },
      {
        title: "Purchase Request Number",
        dataIndex: "prNumber",
        key: "prNumber",
        width: 200,
      },
      {
        title: "Indent Date",
        dataIndex: "indentDate",
        key: "indentDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Contractor",
        dataIndex: "contractorName",
        key: "contractorName",
        width: 200,
      },
      {
        title: "Requested By",
        dataIndex: "requestedById",
        key: "requestedById",
        width: 150,
      },
      {
        title: "Need By Date",
        dataIndex: "needByDate",
        key: "needByDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Delivery Address ID",
        dataIndex: "deliveryAddressId",
        key: "deliveryAddressId",
        width: 150,
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
      },
      {
        title: "Required Quantity",
        dataIndex: "requestedQuantity",
        key: "requestedQuantity",
        width: 150,
      },
      {
        title: "UOM",
        dataIndex: "uomName",
        key: "uomName",
        width: 120,
      },
      {
        title: "Specification",
        dataIndex: "specifications",
        key: "specifications",
        width: 200,
      },
      {
        title: "Block/Villa/Tower Name",
        dataIndex: "unitName",
        key: "unitName",
        width: 200,
      },
      {
        title: "Floor Name",
        dataIndex: "floorNo",
        key: "floorNo",
        width: 150,
      },
      {
        title: "Flat Name",
        dataIndex: "subUnitName",
        key: "subUnitName",
        width: 150,
      },
      {
        title: "Location",
        dataIndex: "locationName",
        key: "locationName",
        width: 200,
      },
      {
        title: "Remarks",
        dataIndex: "remarks",
        key: "remarks",
        width: 200,
      },
    ],
    tableWidth: 3500,
  },
  "purchase-order-upload": {
    title: "Purchase Order Upload",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        fixed: "left",
        render: (status: any, record: any) => {
          const errorData = record?.Error;
          const errorsList = Array.isArray(errorData)
            ? errorData
            : errorData
              ? [errorData]
              : [];

          const isFailed = errorsList.length > 0 || status === "Failed";

          return isFailed ? (
            <Popover
              placement="right"
              title={<span style={{ color: "red" }}>Failed</span>}
              content={
                <div>
                  {errorsList.map((err: string, i: number) => (
                    <p key={i}>{err}</p>
                  ))}
                </div>
              }
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
              content={<p>{record?.prNumber} is a valid record</p>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          );
        },
      },
      {
        title: "Site Name",
        dataIndex: "siteName",
        key: "siteName",
        width: 200,
      },
      {
        title: "Purchase Request Number",
        dataIndex: "purchaseRequestNumber",
        key: "purchaseRequestNumber",
        width: 220,
      },
      {
        title: "PO Number",
        dataIndex: "poNumber",
        key: "poNumber",
        width: 200,
      },
      {
        title: "PO Description",
        dataIndex: "poDescription",
        key: "poDescription",
        width: 250,
      },
      {
        title: "PO Date",
        dataIndex: "poDate",
        key: "poDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Created By",
        dataIndex: "createdBy",
        key: "createdBy",
        width: 150,
      },
      {
        title: "Vendor Name",
        dataIndex: "vendorName",
        key: "vendorName",
        width: 200,
      },
      {
        title: "Contractor Name",
        dataIndex: "contractorName",
        key: "contractorName",
        width: 200,
      },
      {
        title: "Budget Line ID",
        dataIndex: "budgetLineId",
        key: "budgetLineId",
        width: 180,
      },
      {
        title: "Need By Date",
        dataIndex: "needByDate",
        key: "needByDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Billing Address ID",
        dataIndex: "billingAddressId",
        key: "billingAddressId",
        width: 180,
      },
      {
        title: "Delivery Address ID",
        dataIndex: "deliveryAddressId",
        key: "deliveryAddressId",
        width: 180,
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
      },
      {
        title: "Required Quantity",
        dataIndex: "requiredQuantity",
        key: "requiredQuantity",
        width: 160,
      },
      { title: "UOM", dataIndex: "uomName", key: "uomName", width: 120 },
      {
        title: "Unit Price",
        dataIndex: "unitPrice",
        key: "unitPrice",
        width: 130,
      },
      {
        title: "GST %",
        dataIndex: "gstPercentage",
        key: "gstPercentage",
        width: 120,
      },
      {
        title: "Block/Villa/Tower Name",
        dataIndex: "unitName",
        key: "unitName",
        width: 200,
      },
      { title: "Floor Name", dataIndex: "floorNo", key: "floorNo", width: 150 },
      {
        title: "Flat Name",
        dataIndex: "subUnitName",
        key: "subUnitName",
        width: 160,
      },
      {
        title: "Location",
        dataIndex: "locationName",
        key: "locationName",
        width: 200,
      },
      { title: "Remarks", dataIndex: "remarks", key: "remarks", width: 200 },
    ],
    tableWidth: 4000,
  },
  "invoice-grn-upload": {
    title: "Invoice GRN Upload",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        fixed: "left",
        render: (status: any, record: any) => {
          const errorData = record?.Error;
          const errorsList = Array.isArray(errorData)
            ? errorData
            : errorData
              ? [errorData]
              : [];

          const isFailed = errorsList.length > 0 || status === "Failed";

          return isFailed ? (
            <Popover
              placement="right"
              title={<span style={{ color: "red" }}>Failed</span>}
              content={
                <div>
                  {errorsList.map((err: string, i: number) => (
                    <p key={i}>{err}</p>
                  ))}
                </div>
              }
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
              content={<p>{record?.prNumber} is a valid record</p>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          );
        },
      },
      {
        title: "PO Number",
        dataIndex: "poNumber",
        key: "poNumber",
        width: 200,
      },
      {
        title: "Invoice Number",
        dataIndex: "invoiceNumber",
        key: "invoiceNumber",
        width: 200,
      },
      {
        title: "Invoice Date",
        dataIndex: "invoiceDate",
        key: "invoiceDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Due Date",
        dataIndex: "dueDate",
        key: "dueDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "IRN",
        dataIndex: "irn",
        key: "irn",
        width: 200,
      },
      {
        title: "E-Way Bill",
        dataIndex: "eWayBillNumber",
        key: "eWayBillNumber",
        width: 150,
      },
      {
        title: "GRN Number",
        dataIndex: "grnNumber",
        key: "grnNumber",
        width: 200,
      },
      {
        title: "Vehicle Number",
        dataIndex: "vehicleNumber",
        key: "vehicleNumber",
        width: 150,
      },
      {
        title: "Delivery Date",
        dataIndex: "deliveryDate",
        key: "deliveryDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Created By ID",
        dataIndex: "createdBy",
        key: "createdBy",
        width: 150,
      },
      {
        title: "Need By Date",
        dataIndex: "needByDate",
        key: "needByDate",
        width: 150,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Delivery Address ID",
        dataIndex: "deliveryAddressId",
        key: "deliveryAddressId",
        width: 180,
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 120,
      },
      {
        title: "UOM",
        dataIndex: "uomName",
        key: "uomName",
        width: 120,
      },
      {
        title: "HSN/SAC",
        dataIndex: "hsnOrSac",
        key: "hsnOrSac",
        width: 150,
      },
      {
        title: "Gate Entry No",
        dataIndex: "gateEntryNo",
        key: "gateEntryNo",
        width: 180,
      },
    ],
    tableWidth: 3000,
  },
  "payments-upload": {
    title: "Payments Upload",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        fixed: "left",
        render: (status: any, record: any) => {
          const errorData = record?.Error;
          const errorsList = Array.isArray(errorData)
            ? errorData
            : errorData
              ? [errorData]
              : [];

          const isFailed = errorsList.length > 0 || status === "Failed";

          return isFailed ? (
            <Popover
              placement="right"
              title={<span style={{ color: "red" }}>Failed</span>}
              content={
                <div>
                  {errorsList.map((err: string, i: number) => (
                    <p key={i}>{err}</p>
                  ))}
                </div>
              }
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
              content={<p>{record?.invoiceNumber} is a valid record</p>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          );
        },
      },
      {
        title: "PO Number",
        dataIndex: "poNumber",
        key: "poNumber",
        width: 200,
      },
      {
        title: "Vendor Name",
        dataIndex: "vendorName",
        key: "vendorName",
        width: 200,
      },
      {
        title: "Invoice Number",
        dataIndex: "invoiceNumber",
        key: "invoiceNumber",
        width: 200,
      },
      {
        title: "Invoice Date",
        dataIndex: "invoiceDate",
        key: "invoiceDate",
        width: 120,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Payment Date",
        dataIndex: "paymentDate",
        key: "paymentDate",
        width: 120,
        render: (text: any) => <span>{dayjs(text).format("DD-MM-YYYY")}</span>,
      },
      {
        title: "Invoice Amount",
        dataIndex: "invoiceAmount",
        key: "invoiceAmount",
        width: 130,
        render: (amount: any) => <span>{amount ? `${amount}/-` : ""}</span>,
      },
      {
        title: "Amount Paid",
        dataIndex: "amountPaid",
        key: "amountPaid",
        width: 130,
        render: (amount: any) => <span>{amount ? `${amount}/-` : ""}</span>,
      },
      {
        title: "Mode of Payment",
        dataIndex: "modeOfPayment",
        key: "modeOfPayment",
        width: 150,
      },
      {
        title: "Bank Name",
        dataIndex: "bankName",
        key: "bankName",
        width: 120,
      },
      {
        title: "Reference #",
        dataIndex: "referenceNumber",
        key: "referenceNumber",
        width: 120,
      },
      {
        title: "Narration",
        dataIndex: "narration",
        key: "narration",
        width: 200,
      },
    ],
    tableWidth: 1500,
  },
  "site-consumption-boq-upload": {
    title: "Site Consumption BOQ Upload",
    columns: [
      {
        title: "Validation Status",
        dataIndex: "status",
        key: "status",
        width: 120,
        fixed: "left",
        render: (status: any, record: any) => {
          const errorData = record?.Error;
          const errorsList = Array.isArray(errorData)
            ? errorData
            : errorData
              ? [errorData]
              : [];

          const isFailed = errorsList.length > 0 || status === "Failed";

          return isFailed ? (
            <Popover
              placement="right"
              title={<span style={{ color: "red" }}>Failed</span>}
              content={
                <div>
                  {errorsList.map((err: string, i: number) => (
                    <p key={i}>{err}</p>
                  ))}
                </div>
              }
            >
              <Badge
                color="outline-danger"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Failed
              </Badge>
            </Popover>
          ) : (
            <Popover
              placement="right"
              title={<span style={{ color: "green" }}>Success</span>}
              content={<p>Row {record?.rowIndex} is a valid record</p>}
            >
              <Badge
                color="outline-success"
                className="ms-3"
                style={{ cursor: "pointer" }}
              >
                Success
              </Badge>
            </Popover>
          );
        },
      },
      {
        title: "BOQ ID",
        dataIndex: "boqId",
        key: "boqId",
        width: 150,
        render: (text: any) => text || "--",
      },
      {
        title: "BOQ Title",
        dataIndex: "boqTitle",
        key: "boqTitle",
        width: 200,
        render: (text: any) => text || "--",
      },
      {
        title: "Site Name",
        dataIndex: "siteName",
        key: "siteName",
        width: 200,
        render: (text: any) => text || "--",
      },
      {
        title: "Contractor Name",
        dataIndex: "contractorName",
        key: "contractorName",
        width: 200,
        render: (text: any) => text || "--",
      },
      {
        title: "BOQ Line Name",
        dataIndex: "boqLineName",
        key: "boqLineName",
        width: 200,
        render: (text: any) => text || "--",
      },
      {
        title: "Tower/Block",
        dataIndex: "unitName",
        key: "unitName",
        width: 180,
        render: (text: any) => text || "--",
      },
      {
        title: "Floor No",
        dataIndex: "floorNo",
        key: "floorNo",
        width: 100,
        render: (text: any) => text || "--",
      },
      {
        title: "Flat",
        dataIndex: "subUnitName",
        key: "subUnitName",
        width: 150,
        render: (text: any) => text || "--",
      },
      {
        title: "Location Name",
        dataIndex: "locationName",
        key: "locationName",
        width: 150,
        render: (text: any) => text || "--",
      },
      {
        title: "Material Name",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
        render: (text: any) => text || "--",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 120,
        render: (text: any) => text || "--",
      },
      {
        title: "UOM",
        dataIndex: "uomName",
        key: "uomName",
        width: 120,
        render: (text: any) => text || "--",
      },
      {
        title: "Segment Type",
        dataIndex: "segmentType",
        key: "segmentType",
        width: 150,
        render: (text: any) => text || "--",
      },
    ],
    tableWidth: 2500,
  },
};

const BulkUploadList = () => {
  const [screenSize, setScreenSize] = useState(0);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [activeReportType, setActiveReportType] = useState(null);
  const [refreshToggle, setRefreshToggle] = useState(false);
  const [activeReportId, setActiveReportId] = useState(null);
  const [pagination, setPagination] = useState<{
    pageSize: number;
    currentPage: number;
    totalPageCount: number;
    totalRowCount: number;
  }>({
    pageSize: 15,
    currentPage: 1,
    totalPageCount: 0,
    totalRowCount: 0,
  });
  const [drawerData, setDrawerData] = useState<{
    columns: any[];
    dataSource: any[];
    tableWidth: number;
  }>({
    columns: [],
    dataSource: [],
    tableWidth: 1000,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const uploadHighlighted = useSelector(
    (state: any) => state.highlight.uploadHighlighted
  );

  const handleDeleteReport = async (reportId: any) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        setDeleting(reportId);
        const res = await uploadApis.deleteExcelCreationById(reportId);
        const { status, message } = res || {};

        if (status) {
          setRefreshToggle((pre) => !pre);
          Swal.fire(
            "Deleted!",
            message || "Report deleted successfully",
            "success"
          );
        } else {
          Swal.fire("Error", message || "Failed to delete report", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error);
      Swal.fire(
        "Error",
        "Something went wrong while deleting the report",
        "error"
      );
    } finally {
      setDeleting(null);
    }
  };

  const handleCreation = async (reportId: any) => {
    try {
      setSubmitting(reportId);
      const res = await uploadApis.processExcelCreationById(reportId);
      const { status, message } = res || {};

      if (status) {
        setRefreshToggle((pre) => !pre);
        Swal.fire(
          "Created",
          message || "Report processed successfully",
          "success"
        );
      } else {
        Swal.fire("Error", message || "Failed to process report", "error");
      }
    } catch (error) {
      console.error("Creation error:", error);
      Swal.fire(
        "Error",
        "Something went wrong while processing the report",
        "error"
      );
    } finally {
      setSubmitting(null);
    }
  };

  const fetchFileContent = async (
    reportId: any,
    currentPage: number = pagination.currentPage,
    pageSize: number = pagination.pageSize
  ) => {
    try {
      setLoading(true);

      const res = await uploadApis.fetchBulkUploadReportById(
        reportId,
        currentPage,
        pageSize
      );
      const { status, data } = res || {};

      if (status && data) {
        const list = data?.convertedJson || [];
        const p = data?.pagination || {};

        setDrawerData((prev) => ({
          ...prev,
          dataSource: list,
        }));

        setPagination({
          pageSize: p.pageSize,
          currentPage: p.currentPage,
          totalPageCount: p.totalPages,
          totalRowCount: p.totalRecords,
        });
      }
    } catch (error) {
      console.error("Error fetching file content:", error);
    } finally {
      setLoading(false);
    }
  };

  // Function to download document
  const downloadDocument = (filePath: string, fileName: string) => {
    try {
      if (!filePath) {
        Swal.fire("Error", "File path not found", "error");
        return;
      }

      const isAbsoluteUrl = /^https?:\/\//i.test(filePath);
      const fullUrl = isAbsoluteUrl
        ? filePath
        : `${window.location.origin}/${filePath.replace(/^\//, "")}`;

      const link = document.createElement("a");
      link.href = fullUrl;
      link.download = fileName || "report.xlsx";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
      Swal.fire(
        "Error",
        "Something went wrong while downloading the file",
        "error"
      );
    }
  };

  // old handleCreation function
  const handleCreation1 = async (reportId: any, requestType: any) => {
    try {
      const formData: any = new FormData();
      formData.append(
        "filesData",
        JSON.stringify({
          module: "MDM",
          requestType,
          action: "Submit",
          reportId,
          processedExcelData: {},
        })
      );
      formData.append("files", JSON.stringify([]));
      const res = await miscService.bulkUpload(formData);
      const { status, error, message } = res || {};
      if (status) {
        setRefreshToggle((pre) => !pre);
        Swal.fire("Created", message, "success");
      }
    } catch (error) {
    } finally {
      setSubmitting(null);
    }
  };

  // old fetchFileContent function
  const fetchOldFileContent = async (
    pagination: {
      pageSize: number;
      currentPage: number;
      totalPageCount: number;
      totalRowCount: number;
    },
    reportId: any
  ) => {
    try {
      setLoading(true);
      const res = await miscService.fetchConvertedJsonListWithPagination({
        reportId,
        pageSize: pagination?.pageSize,
        paginationId: pagination?.currentPage,
      });
      const { status, data } = res || {};
      if (status) {
        const { count, list, noOfPages } = data;
        setPagination(() => {
          return {
            ...pagination,
            totalPageCount: noOfPages,
            totalRowCount: count,
          };
        });
        setDrawerData((pre) => {
          return {
            ...pre,
            dataSource: list,
          };
        });
        console.log("list", list);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  useEffect(() => {
    if (uploadHighlighted) {
      dispatch(setUploadHighlight(false));
    }
  }, [uploadHighlighted, dispatch]);

  const columns: any = [
    {
      title: "Report #",
      dataIndex: "reportId",
      key: "reportId",
      width: 200,
    },
    {
      title: "Report Name",
      dataIndex: "reportType",
      key: "reportType",
      width: 250,
      render: (text: any) => <span>{drawerColConfig[text]?.title}</span>,
    },
    {
      title: "Date & Time",
      dataIndex: "requestedDate",
      key: "requestedDate",
      width: 200,
      render: (text: any) => (
        <span>{dayjs(text)?.format("DD-MM-YYYY hh:mm:ss")}</span>
      ),
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (text: any, record: any) => {
        if (record?.uploadStatus == "Submit" && record?.status == "Processed")
          return (
            <div className="justify-start align-center">
              <h6
                className={`tb-status ms-1`}
                style={{
                  color: `green`,
                  fontSize: "14px",
                }}
              >
                <CheckCircleOutlined /> Created Successfully
              </h6>
            </div>
          );
        const status = record?.status;
        switch (status) {
          case "Processing":
            return (
              <div className="justify-start align-center">
                <h6
                  className={`tb-status ms-1`}
                  style={{
                    color: `orange`,
                    fontSize: "14px",
                  }}
                >
                  <SyncOutlined /> Processing{" "}
                  <ReactTyped
                    strings={["...."]}
                    typeSpeed={50}
                    backSpeed={10}
                    loop
                    showCursor={false}
                  />
                </h6>
              </div>
            );
          case "Failed":
            return (
              <div className="justify-start align-center">
                <h6
                  className={`tb-status ms-1`}
                  style={{
                    color: `red`,
                    fontSize: "14px",
                  }}
                >
                  <CloseCircleOutlined /> Failed
                </h6>
              </div>
            );
          case "Error":
            return (
              <div className="justify-start align-center">
                <h6
                  className={`tb-status ms-1`}
                  style={{
                    color: `red`,
                    fontSize: "14px",
                  }}
                >
                  <CloseCircleOutlined /> Error In File
                </h6>
              </div>
            );
          case "Processed":
            return (
              <div className="justify-start align-center">
                <h6
                  className={`tb-status ms-1`}
                  style={{
                    color: `green`,
                    fontSize: "14px",
                  }}
                >
                  <span id={`ProcessedStatus-${record?.reportId}`}>
                    <CheckCircleOutlined /> Processed Successfully
                  </span>
                  <TooltipComponent
                    iconClass="info-circle text-info"
                    icon={"info"}
                    id={`ProcessedStatus-${record?.reportId}`}
                    direction="left"
                    text={"Click On Create Button To Complete Creation Process"}
                    containerClassName={"mt-1"}
                  />
                </h6>
              </div>
            );
          default:
            return (
              <div className="justify-start align-center">
                <h6
                  className={`tb-status ms-1`}
                  style={{
                    color: `black`,
                    fontSize: "14px",
                  }}
                >
                  {record?.status}
                </h6>
              </div>
            );
        }
      },
    },
    {
      title: "Action",
      key: "action",
      width: 200,
      render: (text: any, record: any) => {
        const reportType = record?.reportType;

        const newActionTypes = [
          "purchase-request-upload",
          "purchase-order-upload",
          "invoice-grn-upload",
          "payments-upload",
          "site-consumption-boq-upload",
        ];

        if (newActionTypes.includes(reportType)) {
          const showDelete = record?.status !== "Processing";

          const downloadIcon = record.filePath && (
            <Tooltip title="Download Uploaded File">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  downloadDocument(
                    record.filePath,
                    `report-${record.reportId}.xlsx`
                  );
                }}
                style={{
                  color: "#1890ff",
                  cursor: "pointer",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon name="download" />
              </span>
            </Tooltip>
          );
          const showCreateButton =
            record?.status === "Processed" &&
            record?.uploadStatus === "Preview";

          if (
            record?.uploadStatus == "Submit" &&
            record?.status == "Processed"
          ) {
            return (
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <span
                  className="inline-link"
                  id={`SuccessStatus-${record?.reportId}`}
                  onClick={() => {
                    setDrawerData((pre: any) => {
                      const _config = drawerColConfig[record?.reportType] || {};
                      return {
                        ...pre,
                        columns: _config?.columns,
                        tableWidth: _config?.tableWidth,
                      };
                    });
                    setActiveReportId(record?.reportId);
                    setActiveReportType(record?.reportType);
                    setPagination((prev) => ({ ...prev, currentPage: 1 }));
                    setDrawerVisible(true);
                    fetchFileContent(record?.reportId);
                  }}
                >
                  <Icon
                    name="eye"
                    style={{ fontSize: "16px", color: "#1890ff" }}
                  />
                </span>

                {showCreateButton && (
                  <span id={`createBtn-${record?.reportId}`}>
                    {submitting == record?.reportId ? (
                      <Button size="sm" color="primary">
                        <Spinner size="sm" color="light" />
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        color="primary"
                        disabled={!!submitting}
                        onClick={() => {
                          setSubmitting(record?.reportId);
                          handleCreation(record?.reportId);
                        }}
                      >
                        Create
                      </Button>
                    )}
                  </span>
                )}

                {downloadIcon}

                {showDelete && (
                  <>
                    {deleting === record?.reportId ? (
                      <Spinner size="sm" color="danger" />
                    ) : (
                      <Icon
                        name="trash"
                        style={{
                          color: "#ff4d4f",
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                        onClick={() => handleDeleteReport(record?.reportId)}
                      />
                    )}
                  </>
                )}
              </div>
            );
          }

          const status = record?.status;
          switch (status) {
            case "Failed":
              return (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <Popover
                    content={<p>{record?.error}</p>}
                    placement="right"
                    title={<span style={{ color: "red" }}>Failed</span>}
                  >
                    <Badge color="outline-danger" style={{ cursor: "pointer" }}>
                      Reason
                    </Badge>
                  </Popover>

                  {downloadIcon}

                  {showDelete && (
                    <>
                      {deleting === record?.reportId ? (
                        <Spinner size="sm" color="danger" />
                      ) : (
                        <Icon
                          name="trash"
                          style={{
                            color: "#ff4d4f",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                          onClick={() => handleDeleteReport(record?.reportId)}
                        />
                      )}
                    </>
                  )}
                </div>
              );

            case "Error":
            case "Processed":
            case "Preview":
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      textDecoration: "none",
                    }}
                    className="inlineTableCellLink"
                    id={`ViewStatus-${record?.reportId}`}
                    onClick={() => {
                      setDrawerData((pre: any) => {
                        const _config =
                          drawerColConfig[record?.reportType] || {};
                        return {
                          ...pre,
                          columns: _config?.columns,
                          tableWidth: _config?.tableWidth,
                        };
                      });
                      setActiveReportId(record?.reportId);
                      setActiveReportType(record?.reportType);
                      setPagination((prev) => ({ ...prev, currentPage: 1 }));
                      setDrawerVisible(true);
                      fetchFileContent(record?.reportId);
                    }}
                  >
                    <Icon
                      name="eye"
                      style={{ fontSize: "16px", color: "#1890ff" }}
                    />
                  </span>

                  {/* CREATE BUTTON for new action types */}
                  {showCreateButton && (
                    <span id={`createBtn-${record?.reportId}`}>
                      {submitting == record?.reportId ? (
                        <Button size="sm" color="primary">
                          <Spinner size="sm" color="light" />
                        </Button>
                      ) : (
                        <Button
                          size="sm"
                          color="primary"
                          disabled={!!submitting}
                          onClick={() => {
                            setSubmitting(record?.reportId);
                            handleCreation(record?.reportId);
                          }}
                        >
                          Create
                        </Button>
                      )}
                    </span>
                  )}

                  {downloadIcon}

                  {showDelete && (
                    <>
                      {deleting === record?.reportId ? (
                        <Spinner size="sm" color="danger" />
                      ) : (
                        <Icon
                          name="trash"
                          style={{
                            color: "#ff4d4f",
                            cursor: "pointer",
                            fontSize: "16px",
                          }}
                          onClick={() => handleDeleteReport(record?.reportId)}
                        />
                      )}
                    </>
                  )}
                </div>
              );

            case "Processing":
              return (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {downloadIcon}
                </div>
              );

            default:
              return showDelete ? (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  {downloadIcon}
                  {deleting === record?.reportId ? (
                    <Spinner size="sm" color="danger" />
                  ) : (
                    <Icon
                      name="trash"
                      style={{
                        color: "#ff4d4f",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                      onClick={() => handleDeleteReport(record?.reportId)}
                    />
                  )}
                </div>
              ) : null;
          }
        }

        // OLD LOGIC for other report types
        if (record?.uploadStatus == "Submit" && record?.status == "Processed") {
          return (
            <>
              <span
                className="inlineTableCellLink ms-3"
                id={`SuccessStatus-${record?.reportId}`}
                onClick={() => {
                  setDrawerData((pre: any) => {
                    const _config = drawerColConfig[record?.reportType] || {};
                    return {
                      ...pre,
                      columns: _config?.columns,
                      tableWidth: _config?.tableWidth,
                    };
                  });
                  setActiveReportId(record?.reportId);
                  setDrawerVisible(true);
                  fetchOldFileContent(pagination, record?.reportId);
                }}
              >
                View
              </span>
              <TooltipComponent
                iconClass="info-circle text-info"
                icon={""}
                id={`SuccessStatus-${record?.reportId}`}
                direction="right"
                text={"Click To See Uploaded File"}
                containerClassName={"mt-1"}
              />
            </>
          );
        }

        const status = record?.status;
        switch (status) {
          case "Failed":
            return (
              <Popover
                content={
                  <div>
                    <p>{record?.error}</p>
                  </div>
                }
                placement="right"
                title={<span style={{ color: "red" }}>Failed</span>}
              >
                <Badge
                  color="outline-danger"
                  className="ms-3"
                  style={{ cursor: "pointer" }}
                >
                  Reason
                </Badge>
              </Popover>
            );
          case "Error":
            return (
              <>
                <span
                  className="inlineTableCellLink ms-3"
                  id={`ErrorStatus-${record?.reportId}`}
                  onClick={() => {
                    setDrawerData((pre: any) => {
                      const _config = drawerColConfig[record?.reportType] || {};
                      return {
                        ...pre,
                        columns: _config?.columns,
                        tableWidth: _config?.tableWidth,
                      };
                    });
                    setActiveReportId(record?.reportId);
                    setDrawerVisible(true);
                    fetchOldFileContent(pagination, record?.reportId);
                  }}
                >
                  View
                </span>
                <TooltipComponent
                  iconClass="info-circle text-info"
                  icon={""}
                  id={`ErrorStatus-${record?.reportId}`}
                  direction="left"
                  text={"Click To See Error"}
                  containerClassName={"mt-1"}
                />
              </>
            );
          case "Processed":
            return (
              <>
                <span
                  className="inlineTableCellLink ms-3"
                  id={`ProcessedViewStatus-${record?.reportId}`}
                  onClick={() => {
                    setDrawerData((pre: any) => {
                      const _config = drawerColConfig[record?.reportType] || {};
                      return {
                        ...pre,
                        columns: _config?.columns,
                        tableWidth: _config?.tableWidth,
                      };
                    });
                    setActiveReportId(record?.reportId);
                    setDrawerVisible(true);
                    fetchOldFileContent(pagination, record?.reportId);
                  }}
                >
                  View
                </span>
                <TooltipComponent
                  iconClass="info-circle text-info"
                  icon={""}
                  id={`ProcessedViewStatus-${record?.reportId}`}
                  direction="left"
                  text={"Click To See Uploaded File"}
                  containerClassName={"mt-1"}
                />
                <span id={`createBtn-${record?.reportId}`} className="ms-3">
                  {submitting == record?.reportId ? (
                    <Button size="sm" color="primary">
                      <Spinner size="sm" color="light" />
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      color="primary"
                      disabled={!!submitting}
                      onClick={() => {
                        setSubmitting(record?.reportId);
                        handleCreation1(record?.reportId, record?.reportType);
                      }}
                    >
                      <span>Create</span>
                      <TooltipComponent
                        iconClass="info-circle text-info"
                        icon={"info"}
                        id={`createBtn-${record?.reportId}`}
                        direction="right"
                        text={"Click To Complete Creation Process"}
                        containerClassName={"mt-1"}
                      />
                    </Button>
                  )}
                </span>
              </>
            );
          default:
            return null;
        }
      },
    },
  ];

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey={window.location.pathname}
        title="Bulk Upload Requested List"
        refresh={refreshToggle}
        columns={columns}
        extra={{
          tableScrollX: 1300,
          clientSideSearch: true,
        }}
        topRightJSX={
          <>
            <PlainButton
              outline
              className="bg-white d-none d-sm-inline-flex"
              onClick={() => navigate(-1)}
            >
              <Icon name="arrow-left"></Icon>
              <span>Back</span>
            </PlainButton>
            <PlainButton
              outline
              className="btn-icon bg-white d-inline-flex d-sm-none"
              onClick={() => navigate(-1)}
            >
              <Icon name="arrow-left"></Icon>
            </PlainButton>
          </>
        }
      />
      <Drawer
        title="File Data Preview"
        placement="right"
        width={"90%"}
        open={drawerVisible}
        onClose={() => {
          setDrawerData(() => {
            return {
              columns: [],
              dataSource: [],
              tableWidth: 1000,
            };
          });
          setPagination(() => {
            return {
              currentPage: 1,
              totalPageCount: 0,
              totalRowCount: 0,
              pageSize: 15,
            };
          });
          setActiveReportId(null);
          setDrawerVisible(false);
        }}
      >
        {loading ? (
          <>
            <Flex align="center" gap="middle" className="pageLoader">
              <Spin size="large" className="m-auto" />
            </Flex>
          </>
        ) : (
          <div className="table-responsive poTable">
            <div
              style={{
                width: screenSize - 230 + "px",
                margin: "0px auto 15px auto",
              }}
            >
              <Table
                className="customTable"
                columns={drawerData?.columns}
                dataSource={drawerData?.dataSource}
                scroll={{ x: drawerData?.tableWidth }}
                bordered
                // onChange={(newPagination) => {
                //   setPagination((pre: any) => {
                //     return {
                //       ...pre,
                //       currentPage: newPagination.current,
                //       pageSize: newPagination.pageSize,
                //     };
                //   });
                //   fetchFileContent(
                //     {
                //       ...pagination,
                //       currentPage: newPagination?.current || 1,
                //       pageSize: newPagination?.pageSize || 15,
                //     },
                //     activeReportId
                //   );
                // }}
                pagination={{
                  current: pagination.currentPage,
                  pageSize: pagination.pageSize,
                  showSizeChanger: true,
                  // pageSizeOptions: ["15", "20", "30", "40", "50"],
                  total: pagination.totalRowCount,
                  onChange: (page, pageSize) => {
                    fetchFileContent(activeReportId, page, pageSize);
                  },
                }}
              />
            </div>
          </div>
        )}
      </Drawer>
    </>
  );
};

export default BulkUploadList;
